import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class SquidCorpse extends OrganicMobCorpse {
	static key = "SquidCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): SquidCorpse {
		const c = new SquidCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
